import {
  AfterContentInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { SessionModalComponent } from 'src/app/shared/components/session-modal/session-modal.component';
import {
  IAsegurableResponde,
  ILineaNegocio,
  IProducto,
  IScreenDim,
} from 'src/app/shared/Entities/entities';
import { paths, productosPath } from 'src/app/shared/helpers/constants';
import { AuthService } from 'src/app/shared/services/auth.service';
import { EventsService } from 'src/app/shared/services/events.service';
import { SessionTimeoutService } from 'src/app/shared/services/session-timeout.service';
import { IMenu, IMenuItem } from './../../shared/Entities/entities';
import { CommonService } from 'src/app/shared/services/common.service';
import { ProductService } from 'src/app/shared/services/product.service';
import { BffDocumentsService } from 'src/app/shared/services/bff-documents.service';
import { menuWidth, LifeMax } from 'src/app/shared/helpers/constants';
import { PopUpFirma } from 'src/app/pages/pop-up-firma/pop-up-firma';
import { PersonService } from 'src/app/shared/services/person.service';
import { environment } from 'src/environments/environment';
import { getLocalStorage } from 'src/app/shared/helpers/helper';
import * as jwt_decode from 'jwt-decode';
import { AppInsightsService } from 'src/app/shared/services/app-insights-service';
import { Event } from 'src/app/shared/enums/insights/event';
import { TermsService } from './../../shared/components/terms/terms.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.sass'],
})
export class NavigationComponent
  implements OnInit, OnDestroy, AfterContentInit {
  visible = false;
  visibleChanchito = false;
  visibleBHP = false;
  visibleTelemed = false;
  urlBHP: string;
  firstChildChanchito = '';
  urlTelemed = 'https://vidasecurity.medismart.live';
  urlBHPTelemed = environment.url.telemedBHP;
  username = '';
  rut = '';
  isLoggedIn$: Observable<boolean>;
  @Input() segurosIndivuales: IProducto[] = [];
  @Input() segurosColectivos: IProducto[] = [];
  @Input() segurosVitalicios: IProducto[] = [];
  @Input() segurosPrivados: IProducto[] = [];
  opened = true;
  showInfome = false;
  over = '';
  menuWidth = menuWidth;
  showLayout = true;
  @Output() public sidenavToggle = new EventEmitter();
  @ViewChild(PopUpFirma) Dialog;

  mainMenu: IMenu = { title: '', route: { path: '' }, items: [] };
  private subscriptions: Subscription[] = [];

  private _timerSubscription: Subscription;
  visibilityPagarProductos = false;
  lifemax = true;
  private screenDim$: Observable<IScreenDim>;
  constructor(
    public router: Router,
    private auth: AuthService,
    private eventsSrv: EventsService,
    private route: ActivatedRoute,
    private idleTimeoutSvc: SessionTimeoutService,
    public dialog: MatDialog,
    private commonSvc: CommonService,
    private personaService: PersonService,
    private productSrv: ProductService,
    private bffService: BffDocumentsService,
    private appInsightsService: AppInsightsService,
    private termsService: TermsService,
  ) {
    this.over = 'side';

    this.screenDim$ = this.commonSvc.screenDim$;
    this.screenDim$.subscribe(res => {
      if (res.width < this.menuWidth) {
        this.opened = false;
        this.over = 'over';
      } else {
        this.opened = true;
        this.over = 'side';
      }
    });

    this.isLoggedIn$ = this.auth.isLoggedInBehavior;
    this.isLoggedIn$.subscribe(islogged => {
      if (!islogged) {
        return;
      }

      this.username = this.auth.getUsername();
      this.rut = this.auth.getRut();
      this.resetSessionTimer();
    });

    const routeSubscription = this.eventsSrv.routeLifeMax$.subscribe(
      lifemax => {
        this.lifemax = lifemax;
      }
    );

    this.subscriptions.push(routeSubscription);

    const pagarSubscription = this.eventsSrv.visibilityPagarProductos$.subscribe(
      visibilityPagarProductos => {
        setTimeout(
          () => (this.visibilityPagarProductos = visibilityPagarProductos)
        );
      }
    );

    this.subscriptions.push(pagarSubscription);

    const informeSubscription = this.eventsSrv.visibilityInformeRentabilidad$.subscribe(
      showInfome => {
        this.showInfome = showInfome;
      }
    );

    this.subscriptions.push(informeSubscription);

    const routerEventsSubscription = this.router.events.subscribe(_ => {
      const currentRoute = this.router.url.toString();
      this.showLayout = currentRoute !== `/${paths.login.path}`;
    });

    this.subscriptions.push(routerEventsSubscription);
  }
  ngAfterContentInit(): void {
    this.MostrarBanner();
  }

  goOncologico() {
    this.appInsightsService.trackEvent(Event.lkBannerOncological);
    var urlSSO = environment.url.sso + '/auth';
    var urlVentaWeb = environment.url.sitioVentasWeb + '/seguro-oncologico';
    var clientId = 'vs-venta-web';
    var url = `${urlSSO}?client_id=${clientId}&redirect_uri=${urlVentaWeb}&response_mode=fragment&response_type=code&scope=openid`;
    window.open(url, '_blank');
  }

  goChanchito(idPoliza: number, nombre: string) {
    this.appInsightsService.trackEvent(Event.lkBannerChanchito);
    this.router.navigate(['productos/individual/detalleSeguro', idPoliza], {
      queryParams: {
        pago: nombre,
      },
      relativeTo: this.route,
    });
  }

  goClubViva() {
    this.appInsightsService.trackEvent(Event.lkBannerClubViva);
    var urlSSO = environment.url.sso + '/auth';
    var urlClubViva = environment.url.clubViva;
    var clientId = environment.ClientIdClubViva;
    const randomState = this.auth.getRandomState();
    var url = `${urlSSO}?client_id=${clientId}&redirect_uri=${urlClubViva}&state=${randomState}&response_type=code&scope=openid`;
    window.open(url, '_blank');
  }

  trackByFn(index: any, item: any) {
    return index;
  }

  public startCounter() {
    if (this._timerSubscription) {
      this._timerSubscription.unsubscribe();
    }
  }

  public resetSessionTimer() {
    this.startCounter();
    this.idleTimeoutSvc.resetTimer();
  }

  ngOnInit() {
    this.startCounter();
    const _idleTimerSubscription = this.idleTimeoutSvc.timeoutExpired.subscribe(
      res => {
        if (res) {
          this.logout();
        } else {
          this.idleTimeoutSvc.setLogout(true);
          const dialogRef = this.dialog.open(SessionModalComponent, {
            width: '290px',
            height: '180px',
            disableClose: true,
            closeOnNavigation: true,
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result) {
              this.auth.refresh(result);
            }
          });
        }
      }
    );
    this.subscriptions.push(_idleTimerSubscription);
    const menuSubscription = this.eventsSrv.menuChange$.subscribe(() => {
      this.mainMenu = this.eventsSrv.getMenu();
      setTimeout(() => {
        const item = this.mainMenu.items.find(_ => _.active);
        const itemChild = item ? item.children.find(_ => _.active) : null;

        if (itemChild) {
          this.setPolicyToInsights(
            itemChild.item,
            item.route && item.route.path ? item.route.path : ''
          );
        }
      }, 0);
      this.muestraChanchito(this.mainMenu as IMenu);
      this.MostrarBannerBHP(this.mainMenu as IMenu); // BHP
      this.showTelemed(this.mainMenu as IMenu);
    });
    this.subscriptions.push(menuSubscription);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  onToggleSidenav() {
    this.sidenavToggle.emit();
    this.opened = this.opened ? !this.opened : true;
  }

  getProducts(data: ILineaNegocio[], lineaNegocio: string) {
    const lista = data.find(d => d.LineaNegocio === lineaNegocio);
    if (!lista) {
      return [];
    }

    return lista.ListaProductos.Producto;
  }

  navigateTo(menu: IMenuItem, item: IMenuItem) {
    menu.children.forEach(i => {
      i.active = false;
    });
    item.active = true;
    this.setPolicyToInsights(
      item.item,
      menu.route && menu.route.path ? menu.route.path : ''
    );

    this.appInsightsService.trackEvent(Event.lkSelectPolicy);

    this.router.navigate(
      [
        `/${menu.route.rootPath}/${menu.route.path}/${
          item.route.path.split('/')[0]
        }`,
        item.id ? item.id : null,
      ],
      {
        queryParams: item.route.params ? item.route.params : null,
        relativeTo: this.route,
      }
    );
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };
  }

  private setPolicyToInsights(policy: any, businessLine: any) {
    this.appInsightsService.policySelected = {
      code: policy.Codigo,
      clientCode: policy.CodigoCliente,
      clientId: policy.IdCliente,
      policyId: policy.IdPoliza,
      name: policy.Nombre,
      policy: policy.Poliza,
      businessLine: businessLine,
    };
  }

  lostFocus(event: any, item: IMenuItem) {
    this.appInsightsService.trackEvent(Event.btnSelectInsured);

    this.appInsightsService.policySelected = null;
    this.appInsightsService.policyId = '';
    const menu = this.eventsSrv.getMenu();
    menu.items.forEach(x =>
      x.route.label !== item.route.label
        ? (x.active = false)
        : x.children.forEach(c => (c.active = false))
    );

    menu.items.find(
      x => x.route.label === item.route.label
    ).active = !item.active;
    this.router.navigate([`${item.route.rootPath}/${item.route.path}`]);
  }

  logout() {
    this.auth.logout().subscribe(data => {});
    this.router.navigate([paths.loginSso.path]);
  }

  misDatos() {
    this.appInsightsService.trackEvent(Event.btnMyData);
    this.router.navigate([`/${productosPath.path}/${paths.misDatos.path}`]);
  }

  cambiarContrasena() {
    this.appInsightsService.trackEvent(Event.btnChangePassword);
    this.router.navigate([
      `/${productosPath.path}/${paths.cambiarContrasena.path}`,
    ]);
  }
  pagarProductos() {
    this.appInsightsService.trackEvent(Event.icPayMyProducts);
    this.router.navigate([
      `/${productosPath.path}/${paths.pagarProductos.path}`,
    ]);
  }

  goInformeRentabilidad() {
    this.appInsightsService.trackEvent(Event.btnProfitabilityReport);
    this.router.navigate([
      `/${productosPath.path}/${paths.informeRentabilidad.path}`,
    ]);
  }

  verifyRoute() {
    return !(
      this.router.url.indexOf(paths.claveTemporal.path) >= 0 ||
      this.router.url.indexOf(paths.firmaElectronica.path) >= 0
    );
  }
  openDialog() {
    this.dialog.open(NavigationComponent);
  }

  openDialog1() {
    this.dialog.open(PopUpFirma);
  }

  esAsegurable(
    rut: number,
    dv: string,
    CodProd: string,
    CodPlan: string,
    RevPlan: string,
    CodCober: string,
    nombre: string,
    apellido: string,
    FechaNacimiento: string,
    pais: string
  ): Observable<IAsegurableResponde> {
    return this.personaService.esAsegurable(
      rut,
      dv,
      CodProd,
      CodPlan,
      RevPlan,
      CodCober,
      nombre,
      apellido,
      FechaNacimiento,
      pais
    );
  }

  muestraChanchito(menu: IMenu) {
    let validation = false;
    let arregloPolizas = [];

    for (let i = 0; i < menu.items.length; i++) {
      for (let j = 0; j < menu.items[i].children.length; j++) {
        if (menu.items[i].route.path === 'individual') {
          arregloPolizas.push(menu.items[i].children[j].id);
        }
      }
    }

    if (arregloPolizas.length > 0) {
      this.productSrv.getResumen(arregloPolizas).subscribe(resumen => {
        if (!validation) {
          let tipoProducto = resumen.TipoProducto;
          let idPoliza = resumen.NumeroPoliza;
          let codRamo = resumen.CodigoRamo;

          if (
            (tipoProducto === 'APV' ||
              tipoProducto === '57 BIS' ||
              tipoProducto === 'Ahorro') &&
            codRamo != LifeMax
          ) {
            validation = true;
            this.visibleChanchito = validation;
            this.firstChildChanchito = idPoliza;
          }
        }
      });
    }
  }
  /**
   * Metodo para mostrar Banner BHP segun links encontrados.
   */
  MostrarBannerBHP(menu: IMenu) {
    let policies: string = '';
    let UserInfo;

    menu.items.forEach(item => {
      item.children.forEach(children => {
        policies += children.id + ',';
      });
    });

    const token = getLocalStorage('token_sso');
    const access_token = token.idToken;
    if (access_token !== null && access_token !== undefined) {
      UserInfo = jwt_decode(access_token);
    }
    const _rutDv: string = UserInfo.rut.replace('-', '');
    this.bffService.getBenefitsLinks(_rutDv, policies).subscribe(benefits => {
      if (benefits.httpCode === 200) {
        this.visibleBHP = true;
        this.urlBHP = benefits.benefitsLinks[0].url;
      }
    });
  }

  MostrarBanner() {
    let dataAux;
    let UserInfo;

    const token = getLocalStorage('token_sso');
    const access_token = token.idToken;
    if (access_token !== null && access_token !== undefined) {
      UserInfo = jwt_decode(access_token);
    }
    const _rut = Number(UserInfo.rut.split('-')[0]);
    const _dv = UserInfo.rut.split('-')[1];
    if (environment.FlagBanner === true) {
      this.personaService.GetClientProfile(_rut, _dv).subscribe(clienteData => {
        if (clienteData.httpCode === 200) {
          dataAux = {
            rut: _rut,
            dv: _dv,
            nombres: clienteData.client.names,
            apelPaterno: clienteData.client.paternalLastName,
            fechaNac: clienteData.client.birthday.substring(0, 10),
          };
          const fechaAux = dataAux.fechaNac.replace(/-/g, '');
          this.esAsegurable(
            _rut,
            _dv,
            environment.Ramo.toString(),
            environment.Plan,
            environment.RevPlan,
            'CSON',
            dataAux.nombres,
            dataAux.apelPaterno,
            fechaAux,
            'Chile'
          ).subscribe(dataAsegurable => {
            if (dataAsegurable.httpCode === 200) {
              this.personaService
                .getMandatoCliente(_rut, _dv)
                .subscribe(mandatoResponde => {
                  if (mandatoResponde.httpCode === 200) {
                    this.visible = true;
                  }
                });
            }
          });
        }
      });
    }
  }

  public showTerms() {
    this.termsService.showTerms = true;
  }

  goTelemed() {
    const confirmation = window.confirm(
      'Al hacer click en aceptar usted dejará su sesión en Vida Security para ser dirigido al sitio de Telemedicina de Medismart. ¿Está seguro de continuar?'
    );
    if (confirmation) {
      if (this.visibleBHP) {
        window.location.href = this.urlBHPTelemed;
      } else {
        window.location.href = this.urlTelemed;
      }
    }
  }

  showTelemed(menu: IMenu) {
    let arregloPolizasCOL = [];

    for (let i = 0; i < menu.items.length; i++) {
      for (let j = 0; j < menu.items[i].children.length; j++) {
        if (menu.items[i].route.path === 'colectivo') {
          arregloPolizasCOL.push(menu.items[i].children[j].id);
        }
      }
    }

    if (arregloPolizasCOL.length == 0) {
      this.visibleTelemed = false;
    } else {
      this.visibleTelemed = true;
    }
  }
}
